import LogEntriesCatalog from './LogEntriesCatalog';
import { LogEntriesCatalogProps, LogEntriesCatalogValueProps } from './types';

export type { LogEntriesCatalogProps, LogEntriesCatalogValueProps };
export default LogEntriesCatalog;
